<router-outlet />

<!-- Diálogo global de sesión expirada (código 1003). Controlado de forma imperativa
     desde SessionExpiredService a través del interceptor HTTP. -->
<hlm-alert-dialog [state]="sessionExpired.isOpen() ? 'open' : 'closed'" [closeOnBackdropClick]="false"
  (closed)="sessionExpired.dismiss()">
  <hlm-alert-dialog-content *hlmAlertDialogPortal>
    <hlm-alert-dialog-header>
      <h2 hlmAlertDialogTitle>Sesión finalizada</h2>
      <p hlmAlertDialogDescription>{{ sessionExpired.message() }}</p>
    </hlm-alert-dialog-header>
    <hlm-alert-dialog-footer>
      <button hlmAlertDialogAction (click)="onSessionExpiredConfirm()">
        Aceptar
      </button>
    </hlm-alert-dialog-footer>
  </hlm-alert-dialog-content>
</hlm-alert-dialog>
